export default "__VITE_ASSET__BHXBdd99__"